














































































































































































































import { mixins } from 'vue-class-component';
import {
  Component, Prop, Vue, PropSync, Watch,
} from 'vue-property-decorator';
import {
  UnitsApi,
  Unit,
  UnitFacility,
  DocumentRequest,
  FilesApi,
} from '@compassdigital/foodworks.ts.sdk';
import { cloneDeep } from 'lodash';
import VueImageLightboxCarousel from 'vue-image-lightbox-carousel';
import AppModule from '@/store/modules/app';
import FacilityEdit from '@/components/Form/Unit/FacilityEdit/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import UnitsUtil from '@/util/UnitUtil';
import FileUtil from '@/util/FileUtil';
import UserModule from '@/store/modules/user';
import ToastModule from '@/store/modules/toast';

@Component({
  components: {
    Textfield,
    PrimaryButton,
    TextButton,
    FacilityEdit,
    VueImageLightboxCarousel,
  },
})
export default class FacilityDetail extends mixins(FileUtil) {
  @PropSync('unitFacility', {}) unitFacilityData!: UnitFacility;

  @PropSync('docImages', { default: () => [] }) docImagesSyn!: any;

  @PropSync('imageItems', {}) imageItem!: any;

  @Prop({}) unitId!: string;

  public edit: boolean = false;

  public saving: boolean = false;

  public cacheFilesImage = {};

  public cachedUnitFacility = {};

  public cachedUnitFacilityDetails = {};

  public showLightbox: boolean = false;

  public activeImage: any = 0;

  public activeImageNew: any = 0;

  public previewImageUrl: string = '';

  public facilityPageInfo: any = {
    arrivalTime: '',
    reportingTime: '',
    serviceTime: {
      to: '',
      from: '',
    },
    avgPrepCount: '',
    uniformPermitted: '',
    uniformNotPermitted: '',
    parkingInformation: '',
    securityInformation: '',
    notes: '',
    unitPictures: [],
  };

  public facilityModal: any = {
    numericError: false,
    timeError: false,
    dialogSync: false,
    imageFiles: '',
  };

  public error: boolean = false;

  public onCancel() {
    this.unitFacilityData = this.cachedUnitFacility;
    this.facilityPageInfo = this.cachedUnitFacilityDetails;
    this.edit = false;
    this.error = false;
  }

  public onEdit() {
    this.cacheFilesImage = cloneDeep(this.docImagesSyn);
    this.cachedUnitFacility = cloneDeep(this.unitFacilityData);
    this.cachedUnitFacilityDetails = cloneDeep(this.facilityPageInfo);
    this.edit = true;
  }

  public async onSaveFacility() {
    if (
      this.unitFacilityData.arrivalTime
      && this.unitFacilityData.reportingTime
      && this.unitFacilityData.avgPrepCount
      && this.unitFacilityData.serviceTime?.to
      && this.unitFacilityData.serviceTime?.from
      && this.unitFacilityData.parkingInformation
      && this.unitFacilityData.uniformPermitted
      && this.unitFacilityData.uniformNotPermitted
      && this.facilityModal.numericError === false
      && this.facilityModal.timeError === false
    ) {
      const facility: UnitFacility = {
        arrivalTime: this.unitFacilityData.arrivalTime,
        reportingTime: this.unitFacilityData.reportingTime,
        serviceTime: this.unitFacilityData.serviceTime,
        serviceType: 'Lunch',
        avgPrepCount: this.unitFacilityData.avgPrepCount,
        uniformPermitted: this.unitFacilityData.uniformPermitted,
        uniformNotPermitted: this.unitFacilityData.uniformNotPermitted,
        parkingInformation: this.unitFacilityData.parkingInformation,
        securityInformation: this.unitFacilityData.securityInformation,
        notes: this.unitFacilityData.notes,
        unitPictures: this.unitFacilityData.unitPictures,
      };
      try {
        this.saving = true;
        const api = new UnitsApi(AppModule.apiConfig);
        const unitUser = await api.patchUnitById(this.unitId, { facility });
        if (unitUser.data) {
          const { data } = unitUser;
          this.unitFacilityData = data.facility as any;
          if (data.facility) {
            this.getFilesImage(data.facility as any);
            this.getFilesImage(data.facility as any);
            this.edit = false;
          }
          this.edit = false;
        }
      } catch (err) {
        const { error } = err.response.data;
        ToastModule.setToast({
          message: error.message,
          timeout: 5000,
        });
      }
      this.saving = false;
    } else {
      this.error = true;
    }
  }

  public async onSaveFacilityInfo() {
    if (
      this.facilityPageInfo.arrivalTime
      && this.facilityPageInfo.reportingTime
      && this.facilityPageInfo.avgPrepCount
      && this.facilityPageInfo.serviceTime
      && this.facilityPageInfo.parkingInformation
      && this.facilityPageInfo.uniformPermitted
      && this.facilityPageInfo.uniformNotPermitted
      && this.facilityModal.numericError === false
    ) {
      const facility: UnitFacility = {
        arrivalTime: this.facilityPageInfo.arrivalTime,
        reportingTime: this.facilityPageInfo.reportingTime,
        serviceTime: this.facilityPageInfo.serviceTime,
        serviceType: 'Lunch',
        avgPrepCount: this.facilityPageInfo.avgPrepCount,
        uniformPermitted: this.facilityPageInfo.uniformPermitted,
        uniformNotPermitted: this.facilityPageInfo.uniformNotPermitted,
        parkingInformation: this.facilityPageInfo.parkingInformation,
        securityInformation: this.facilityPageInfo.securityInformation,
        notes: this.facilityPageInfo.notes,
        unitPictures: this.facilityPageInfo.unitPictures,
      };
      try {
        const api = new UnitsApi(AppModule.apiConfig);
        const unitUser = await api.patchUnitById(this.unitId, { facility });
        if (unitUser.data) {
          const { data } = unitUser;
          this.unitFacilityData = data.facility as any;
          if (data.facility) {
            this.getFilesImage(data.facility as any);
            this.edit = false;
          }
          this.edit = false;
        }
      } catch (err) {
        const { error } = err.response.data;
        ToastModule.setToast({
          message: error.message,
          timeout: 5000,
        });
      }
    } else {
      this.error = true;
    }
  }

  public async getFilesImage(facility: UnitFacility) {
    const imageDoc = !facility.unitPictures
      || facility.unitPictures.map(async (id: string) => {
        try {
          const api = new FilesApi(AppModule.apiConfig);
          const fileResponse = await api.getFile(id);
          const { data } = fileResponse;
          if (data) {
            const { documents } = data as any;
            return documents;
          }
        } catch (err) {
          const { error } = err.response.data;
          ToastModule.setToast({
            message: error.message,
            timeout: 5000,
          });
        }
        return '';
      });

    Promise.all(imageDoc as any).then((images) => {
      const validImages = (images as any[]).filter((doc) => doc);
      this.docImagesSyn = validImages as any;
      this.imageItem = UnitsUtil.formatImages(
        validImages.filter((doc) => !this.isPdf(doc)),
      );
      this.$nextTick(() => {
        this.setActiveToFirstImage();
      });
    });
  }

  public isPdf(doc: any) {
    return UnitsUtil.isPdfDocument(doc);
  }

  public downloadPdf(doc: any) {
    this.downloadStaticFile({
      url: doc.url,
      name: doc.documentName || 'document.pdf',
    });
  }

  public setPreviewByIndex(imageIndex: number) {
    const doc = this.docImagesSyn?.[imageIndex];
    if (!doc || this.isPdf(doc)) {
      return;
    }
    this.activeImageNew = imageIndex;
    this.previewImageUrl = doc.url;
  }

  public setActiveToFirstImage() {
    if (!Array.isArray(this.docImagesSyn) || !this.docImagesSyn.length) {
      this.previewImageUrl = '';
      return;
    }
    const current = this.docImagesSyn[this.activeImageNew];
    if (current && !this.isPdf(current)) {
      this.previewImageUrl = current.url;
      return;
    }
    const index = this.docImagesSyn.findIndex(
      (doc: any) => doc && !this.isPdf(doc),
    );
    if (index >= 0) {
      this.setPreviewByIndex(index);
    }
  }

  @Watch('docImagesSyn', { immediate: true })
  onDocImagesChange() {
    this.$nextTick(() => {
      this.setActiveToFirstImage();
    });
  }

  public clickOnImage() {
    this.showLightbox = true;
    this.$nextTick(() => {
      const lightbox = this.$refs.lightbox as Vue & {
        showImage: (index: number) => void;
      };
      if (lightbox?.showImage) {
        lightbox.showImage(this.getLightboxIndex());
      }
    });
  }

  public getLightboxIndex(): number {
    if (!this.previewImageUrl || !this.imageItem?.length) {
      return 0;
    }
    const index = this.imageItem.findIndex(
      (img: { path: string }) => img.path === this.previewImageUrl,
    );
    return index >= 0 ? index : 0;
  }

  public nextImage() {
    if (!this.docImagesSyn?.length) {
      return;
    }
    const { length } = this.docImagesSyn;
    let active = this.activeImageNew;
    for (let i = 0; i < length; i += 1) {
      active = (active + 1) % length;
      if (!this.isPdf(this.docImagesSyn[active])) {
        this.setPreviewByIndex(active);
        return;
      }
    }
  }

  public prevImage() {
    if (!this.docImagesSyn?.length) {
      return;
    }
    const { length } = this.docImagesSyn;
    let active = this.activeImageNew;
    for (let i = 0; i < length; i += 1) {
      active = active - 1 < 0 ? length - 1 : active - 1;
      if (!this.isPdf(this.docImagesSyn[active])) {
        this.setPreviewByIndex(active);
        return;
      }
    }
  }

  public activateImage(imageIndex: number) {
    this.setPreviewByIndex(imageIndex);
  }

  get hasMediaFiles() {
    return Array.isArray(this.docImagesSyn) && this.docImagesSyn.length > 0;
  }

  get hasMultipleImages() {
    return this.docImagesSyn?.filter(
      (doc: any) => doc && !this.isPdf(doc),
    ).length > 1;
  }

  get accessAdminUser() {
    if (
      UserModule.currentRole === 'fw_admin'
      || UserModule.currentRole === 'fw_manager'
      || UserModule.currentRole === 'unit_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }
}
